/* Public recently-viewed history only. Swym's customer-owned Favorites adapter is pending. */
window.SimpsonHubProducts = class {
  constructor(hub) {
    this.hub = hub;
    this.listeners = new AbortController();
    hub.addEventListener('click', event => {
      if (event.target.closest('[data-hub-recent-retry]')) this.activate(true);
      const control = event.target.closest('[data-hub-slide]');
      if (control) {
        const track = control.closest('[data-hub-shelf]').querySelector('[data-hub-product-track]');
        track.scrollBy({left: Number(control.dataset.hubSlide) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    }, {signal:this.listeners.signal});
    window.addEventListener('storage', event => { if(event.key === 'hypertheme:recently-viewed') this.activate(); }, {signal:this.listeners.signal});
  }
  async activate(retry = false) {
    const shelves = [...this.hub.querySelectorAll('[data-hub-shelf="recent"]')];
    if (!shelves.length) return;
    let ids = [];
    try { const history = JSON.parse(localStorage.getItem('hypertheme:recently-viewed') || '[]'); if(Array.isArray(history)) ids = [...new Set(history.filter(id => Number.isSafeInteger(id) && id > 0))].slice(0,8); } catch (_) {}
    const key = ids.join(',');
    if (!retry && key === this.historyKey) return;
    this.historyKey = key;
    this.request?.abort();
    shelves.forEach(shelf => { shelf.hidden = !ids.length; shelf.querySelector('[data-hub-product-track]').replaceChildren(); shelf.querySelector('[data-hub-recent-error]').hidden = true; shelf.querySelector('[data-hub-shelf-controls]').hidden = true; });
    if(!ids.length) return;
    this.request = new AbortController();
    const request = this.request;
    const timeout = setTimeout(() => request.abort(), 12000);
    try {
      const url = new URL(this.hub.dataset.searchUrl, location.origin);
      if(url.origin !== location.origin) throw new Error('Invalid search origin');
      url.searchParams.set('section_id','customer-hub-recent-products');
      url.searchParams.set('type','product');
      url.searchParams.set('q',ids.map(id => `id:${id}`).join(' OR '));
      const response = await fetch(url, {signal:request.signal, credentials:'same-origin'});
      if(!response.ok) throw new Error('Search unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      if(this.request !== request || this.listeners.signal.aborted) return;
      const products = [...document.querySelectorAll('[data-hub-recent-product]')].filter(card => ids.includes(Number(card.dataset.hubRecentProduct)));
      shelves.forEach(shelf => {
        const track = shelf.querySelector('[data-hub-product-track]');
        track.replaceChildren(...products.map(product => product.cloneNode(true)));
        shelf.hidden = !products.length;
        shelf.querySelector('[data-hub-shelf-controls]').hidden = products.length < 2;
      });
    } catch (_) {
      if(this.request !== request || this.listeners.signal.aborted) return;
      this.historyKey = undefined;
      shelves.forEach(shelf => { shelf.querySelector('[data-hub-recent-error]').hidden = false; });
    } finally {clearTimeout(timeout);}
  }
  destroy() {this.listeners.abort(); this.request?.abort();}
};
